export default __webpack_public_path__ + "static/media/plumber.ba610989.png";